import axios from './http';
import base from './base';

/**
 * post方法，对应post请求
 * @desc注册请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

// 密码登录接口
export function login(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userAuth/login`,
    method: 'post',
    data: data,
    headers: {
      notLoading: true
    }
  });
}

// 获取短信登录验证码
export function getSmsLoginCaptcha(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/captcha/getSmsLoginCaptcha`,
    method: 'post',
    headers: {
      notLoading: true
    },
    data: data,
  });
}

// 短息登录接口
export function smsLogin(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userAuth/smsLogin`,
    method: 'post',
    headers: {
      notLoading: true
    },
    data: data,
  });
}

// 退出登录get请求
export function logout(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userAuth/logout`,
    method: 'get',
    params,
  });
}

// 获取充值密码验证码
export function getRechargeCaptcha(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/captcha/getSmsFindPasswordCaptcha`,
    method: 'post',
    data: data,
  });
}

// 用户找回密码
export function findPassword(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userAuth/findPassword`,
    method: 'post',
    data: data,
  });
}

// 获取验证码
export function getCaptcha(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/captcha/getCaptcha`,
    method: 'get',
    params,
  });
}

// 获取微信二维码
export function getQrCode(params) {
  return axios({
    url: `${base.wxUrl}/wxpa/getQrCode`,
    method: 'get',
    params,
  });
}

// 判断用户是否已经关注公众号
export function isSubscribe(params) {
  return axios({
    url: `${base.wxUrl}/wxpa/isSubscribe`,
    method: 'get',
    params,
    headers: {
      notLoading: true
    },
  });
}

// 判断微信是否已绑定手机号
export function checkWcBingMobile(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/wechat/checkWcBingMobile`,
    method: 'get',
    params,
  });
}

// 获取微信绑定手机号验证码
export function getSmsBindingWechatCaptcha(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/captcha/getSmsBindingWechatCaptcha`,
    method: 'post',
    data: data,
  });
}

// 微信绑定手机号
export function wcBingMobile(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/wechat/wcBingMobile`,
    method: 'post',
    data: data,
  });
}

// 发送公众号消息
export function sendTemplateMessage(params) {
  return axios({
    url: `${base.wxUrl}/wxpa/sendTemplateMessage`,
    method: 'get',
    params,
  });
}